@use "sass:string";
@use "sass:list";

@function kebab-to-camel($input) {
    $segments: string.split($input, "-");
    $result: "";

    @for $i from 1 through list.length($segments) {
        $s: list.nth($segments, $i);

        @if $i == 1 {
            $result: "#{$result}#{$s}";
        } @else {
            $first-letter: string.to-upper-case(string.slice($s, 1, 1));
            $rest: string.slice($s, 2);
            $result: "#{$result}#{$first-letter}#{$rest}";
        }
    }

    @return $result;
}

/**
 * Should work with ul, ol, and dl, including situations where dls are
 * wrapped in a div.
 */
:where(.listReset, .listReset ul) {
    margin: 0;
    padding: 0;
    list-style: none;
}

:where(.listReset) > :where(li, dt, dd),
:where(.listReset) > :where(div) dd {
    margin: 0;
    padding: 0;
}
